module.exports = __webpack_public_path__ + "img/door-open-fill.5340528c.svg";